import { useState, useEffect } from 'react';
import { navLinks } from '@/mocks/home';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[68px]">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick('#hero');
            }}
            className="flex items-center gap-2 text-foreground-950 no-underline"
          >
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-book-open-line text-lg text-background-50"></i>
            </div>
            <span className="font-heading font-bold text-lg whitespace-nowrap">飞飞漫画网</span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(link.href);
                }}
                className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-md hover:bg-primary-50/70 transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <button
              type="button"
              className="flex items-center gap-1.5 px-3 py-2 text-sm font-medium text-foreground-600 hover:text-foreground-900 rounded-md hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-search-line text-base"></i>
              <span>搜索</span>
            </button>
            <a
              href="#app"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick('#app');
              }}
              className="flex items-center gap-1.5 px-4 py-2 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-colors whitespace-nowrap cursor-pointer no-underline"
            >
              <i className="ri-download-line text-base"></i>
              <span>APP下载</span>
            </a>
          </div>

          <button
            type="button"
            className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-700 hover:text-foreground-950 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <nav className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(link.href);
                }}
                className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50/70 rounded-md transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                {link.label}
              </a>
            ))}
            <div className="flex gap-2 pt-2 border-t border-background-200/70 mt-1">
              <button
                type="button"
                className="flex-1 flex items-center justify-center gap-1.5 px-3 py-2 text-sm font-medium text-foreground-600 bg-background-100 rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-search-line text-base"></i>
                <span>搜索</span>
              </button>
              <a
                href="#app"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick('#app');
                }}
                className="flex-1 flex items-center justify-center gap-1.5 px-3 py-2 text-sm font-semibold text-background-50 bg-primary-500 rounded-md transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-download-line text-base"></i>
                <span>APP下载</span>
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}